import { useMemo } from 'react';
import { Project } from '@brg/api';
import { useProfile, bProfile } from '@brg/auth';
import { ProfileRole } from 'core/utils/bProfile';
import { HsePolicies } from 'shared/constants/HsePolicies';
import { ProjectDelegate } from '../../../../project-delegate';
import { BookDelegate } from '../../../../_deziiign/books/core/book-delegate';
import { isExpert, isExpertByPolicy } from 'shared/helpers/utils/TagsUtils';
import { extractIds } from 'shared/constants/extractIds';
import { useBreakpoint } from '@brg/ui';
import { LayoutConst } from 'core';
import useQueryState from 'shared/hooks/useQueryState';
import useQueryParamsController from 'shared/hooks/useQueryParamsController';
import { TABS } from 'shared/pages/opencallsPage/GetCompetitionItem/GetCompetitionItem';
import { useRouteMatch } from 'react-router-dom';
interface UseProjectCardPermissionsProps {
  project?: Project;
  isEditable?: boolean;
  isSelectable?: boolean;
  isCanNotParticipate?: boolean;
  isCanNotBeDraft?: boolean;
  isBookChapter?: boolean;
  isJury?: boolean;
}

export const useProjectCardPermissions = ({
  project,
  isEditable,
  isSelectable,
  isCanNotParticipate,
  isCanNotBeDraft,
  isBookChapter,
  isJury,
}: UseProjectCardPermissionsProps) => {
  const profile = useProfile();
  const isTab = useBreakpoint(LayoutConst.screen.m);
  const [{tab}] = useQueryState();
  const isCompetition = !!useRouteMatch('/competition/:id');

  const isEditableLocal = useMemo(
    () => ProjectDelegate.isProjectEditableFor(profile, project),
    [profile, project]
  );

  const canBeDraft = useMemo(
    () => !project?.book && !isBookChapter && !isCanNotBeDraft,
    [project, isBookChapter, isCanNotBeDraft]
  );

  const isMe = useMemo(() => {
    if (!project || !profile) return false;
    return (
      project?.author?.accountId === (profile?.accountId ?? '-') ||
      project?.coAuthors?.some?.((v: any) => v.accountId === (profile?.accountId ?? '-'))
    );
  }, [project, profile]);

  const isCreator = useMemo(
    () => project && project?.creatorId && project?.creatorId === profile?.accountId,
    [project, profile]
  );

  const canEditFolders = useMemo(() => isMe, [isMe]);

  const isTagExpert = useMemo(() => isExpert(profile, project?.tagsID), [profile, project?.tagsID]);
  const isTagExpertByPolicy = useMemo(
    () => isExpertByPolicy(profile, project?.tagsID),
    [profile, project?.tagsID]
  );

  const isTagModer_Expert = useMemo(() => {
    if (!profile || !project) return false;
    const { tags: projectTags = [] } = project;
    // @ts-ignore
    const { tagsExpert } = profile;
    const moderatedTags_Expert = extractIds(tagsExpert?.map((i: any) => i?.tagIds));
    return (
      isTagExpert &&
      !!moderatedTags_Expert?.length &&
      projectTags &&
      projectTags.some(({ tagId, isEducationTag }) => moderatedTags_Expert.includes(tagId))
    );
  }, [project, profile, isTagExpert]);

  const isTagModer_ExpertByPolicy = useMemo(() => {
    if (!profile || !project) return false;
    const { tags: projectTags = [] } = project;

    const hasTagExpertPolicy =
      profile &&
      profile.rolesList &&
      Array.isArray(profile.rolesList) &&
      profile.rolesList.some((x) => x.startsWith(HsePolicies.tag_expert_prefix));

    return (
      isTagExpertByPolicy &&
      hasTagExpertPolicy &&
      projectTags &&
      projectTags.some(
        ({ tagId, isEducationTag }) =>
          isEducationTag &&
          profile.rolesList.some((x) => x.startsWith(`${HsePolicies.tag_expert_prefix}${tagId}`))
      )
    );
  }, [project, profile, isTagExpertByPolicy]);

  const hasEditProjectPolicy = useMemo(
    () =>
      profile &&
      profile.rolesList &&
      Array.isArray(profile.rolesList) &&
      new ProfileRole(HsePolicies.edit_project).containsIn(profile.rolesList),
    [profile]
  );

  const canAddBookmark = useMemo(() => {
    return isTab
  } , [isTab])

  const isCanBeRepost = useMemo(() => {
    return isTab
  } , [isTab])

  const isHeadCommentVisible = useMemo(() => {
    const isCreator = !!profile && profile?.accountId === project?.creatorId
    const isProjectsTab = tab === TABS.projects
    return (isCreator || isJury) && isProjectsTab && isCompetition
  } , [isTab, profile, project, tab, isJury, isCompetition])

  const isMoreVisible = useMemo(() => {
    return (
      isEditable || isEditableLocal || isSelectable || isCanNotParticipate || isTagModer_Expert || isHeadCommentVisible
    );
  }, [isEditable, isEditableLocal, isSelectable, isCanNotParticipate, isTagModer_Expert, isHeadCommentVisible]);



  return {
    isEditableLocal,
    canBeDraft,
    isMe,
    isCreator,
    canEditFolders,
    isHeadCommentVisible,
    isTagModer_Expert,
    isTagModer_ExpertByPolicy,
    hasEditProjectPolicy,
    isMoreVisible,
    isTagExpert: isTagModer_Expert || isTagModer_ExpertByPolicy,
    canAddBookmark,
    isCanBeRepost,
  };
};
import { useMemo } from 'react';
import { Project } from '@brg/api';
import { useProfile, bProfile } from '@brg/auth';
import { ProfileRole } from 'core/utils/bProfile';
import { HsePolicies } from 'shared/constants/HsePolicies';
import { ProjectDelegate } from '../../../../project-delegate';
import { BookDelegate } from '../../../../_deziiign/books/core/book-delegate';
import { isExpert, isExpertByPolicy } from 'shared/helpers/utils/TagsUtils';
import { extractIds } from 'shared/constants/extractIds';
import { useBreakpoint } from '@brg/ui';
import { LayoutConst } from 'core';
import useQueryState from 'shared/hooks/useQueryState';
import useQueryParamsController from 'shared/hooks/useQueryParamsController';
import { TABS } from 'shared/pages/opencallsPage/GetCompetitionItem/GetCompetitionItem';
import { useRouteMatch } from 'react-router-dom';
interface UseProjectCardPermissionsProps {
  project?: Project;
  isEditable?: boolean;
  isSelectable?: boolean;
  isCanNotParticipate?: boolean;
  isCanNotBeDraft?: boolean;
  isBookChapter?: boolean;
  isJury?: boolean;
}

export const useProjectCardPermissions = ({
  project,
  isEditable,
  isSelectable,
  isCanNotParticipate,
  isCanNotBeDraft,
  isBookChapter,
  isJury,
}: UseProjectCardPermissionsProps) => {
  const profile = useProfile();
  const isTab = useBreakpoint(LayoutConst.screen.m);
  const [{tab}] = useQueryState();
  const isCompetition = !!useRouteMatch('/competition/:id');

  const isEditableLocal = useMemo(
    () => ProjectDelegate.isProjectEditableFor(profile, project),
    [profile, project]
  );

  const canBeDraft = useMemo(
    () => !project?.book && !isBookChapter && !isCanNotBeDraft,
    [project, isBookChapter, isCanNotBeDraft]
  );

  const isMe = useMemo(() => {
    if (!project || !profile) return false;
    return (
      project?.author?.accountId === (profile?.accountId ?? '-') ||
      project?.coAuthors?.some?.((v: any) => v.accountId === (profile?.accountId ?? '-'))
    );
  }, [project, profile]);

  const isCreator = useMemo(
    () => project && project?.creatorId && project?.creatorId === profile?.accountId,
    [project, profile]
  );

  const canEditFolders = useMemo(() => isMe, [isMe]);

  const isTagExpert = useMemo(() => isExpert(profile, project?.tagsID), [profile, project?.tagsID]);
  const isTagExpertByPolicy = useMemo(
    () => isExpertByPolicy(profile, project?.tagsID),
    [profile, project?.tagsID]
  );

  const isTagModer_Expert = useMemo(() => {
    if (!profile || !project) return false;
    const { tags: projectTags = [] } = project;
    // @ts-ignore
    const { tagsExpert } = profile;
    const moderatedTags_Expert = extractIds(tagsExpert?.map((i: any) => i?.tagIds));
    return (
      isTagExpert &&
      !!moderatedTags_Expert?.length &&
      projectTags &&
      projectTags.some(({ tagId, isEducationTag }) => moderatedTags_Expert.includes(tagId))
    );
  }, [project, profile, isTagExpert]);

  const isTagModer_ExpertByPolicy = useMemo(() => {
    if (!profile || !project) return false;
    const { tags: projectTags = [] } = project;

    const hasTagExpertPolicy =
      profile &&
      profile.rolesList &&
      Array.isArray(profile.rolesList) &&
      profile.rolesList.some((x) => x.startsWith(HsePolicies.tag_expert_prefix));

    return (
      isTagExpertByPolicy &&
      hasTagExpertPolicy &&
      projectTags &&
      projectTags.some(
        ({ tagId, isEducationTag }) =>
          isEducationTag &&
          profile.rolesList.some((x) => x.startsWith(`${HsePolicies.tag_expert_prefix}${tagId}`))
      )
    );
  }, [project, profile, isTagExpertByPolicy]);

  const hasEditProjectPolicy = useMemo(
    () =>
      profile &&
      profile.rolesList &&
      Array.isArray(profile.rolesList) &&
      new ProfileRole(HsePolicies.edit_project).containsIn(profile.rolesList),
    [profile]
  );

  const canAddBookmark = useMemo(() => {
    return isTab
  } , [isTab])

  const isCanBeRepost = useMemo(() => {
    return isTab
  } , [isTab])

  const isHeadCommentVisible = useMemo(() => {
    const isCreator = !!profile && profile?.accountId === project?.creatorId
    const isProjectsTab = tab === TABS.projects
    return (isCreator || isJury) && isProjectsTab && isCompetition
  } , [isTab, profile, project, tab, isJury, isCompetition])

  const isMoreVisible = useMemo(() => {
    return (
      isEditable || isEditableLocal || isSelectable || isCanNotParticipate || isTagModer_Expert || isHeadCommentVisible
    );
  }, [isEditable, isEditableLocal, isSelectable, isCanNotParticipate, isTagModer_Expert, isHeadCommentVisible]);



  return {
    isEditableLocal,
    canBeDraft,
    isMe,
    isCreator,
    canEditFolders,
    isHeadCommentVisible,
    isTagModer_Expert,
    isTagModer_ExpertByPolicy,
    hasEditProjectPolicy,
    isMoreVisible,
    isTagExpert: isTagModer_Expert || isTagModer_ExpertByPolicy,
    canAddBookmark,
    isCanBeRepost,
  };
};
